import { createSlice } from '@reduxjs/toolkit';
import { defaultValues } from '../data/DefaultTranslationValues';
export const initialState = [];
export const BusinessUnitsSlice = createSlice({
  name: 'businessUnits',
  initialState,
  reducers: {}
});
export const allBusinessUnit = (portalId, allBusinessUnitsText) => {
  return {
    hubId: portalId,
    name: allBusinessUnitsText || defaultValues['nav.tools.allBusinessUnits'],
    allUsersHaveAccess: true,
    id: 'ALL'
  };
};
export const getBusinessUnits = state => {
  return [allBusinessUnit(state.portal.portalId, state.translations['nav.tools.allBrands']), ...state.businessUnits];
};
export default BusinessUnitsSlice.reducer;